<template>
  <div
    class="flex-1 flex flex-col items-center justify-center text-center gap-6 min-h-screen p-4 md:p-6 lg:p-8"
    data-testid="email-verification"
  >
    <div v-if="isLoading" role="status" :aria-busy="true">
      <h2 class="font-display text-xl font-semibold mb-4 text-arena-text-bright tracking-[0.04em]">
        Verifying your email...
      </h2>
    </div>

    <div v-else-if="success">
      <h2 class="font-display text-xl font-semibold mb-4 text-energy-primary tracking-[0.04em]">
        Email verified!
      </h2>
      <p class="text-base text-arena-text-muted mb-6">
        Your account is now fully activated. You can join matchmaking.
      </p>
      <PrimeButton
        @click="$emit('continue')"
        data-testid="verification-continue-button"
        class="min-h-12 min-w-12 touch-manipulation"
      >
        Continue
      </PrimeButton>
    </div>

    <div v-else role="alert">
      <h2 class="font-display text-xl font-semibold mb-4 text-energy-danger tracking-[0.04em]">
        Verification failed
      </h2>
      <p class="text-base text-arena-text-muted mb-6">
        {{ errorMessage }}
      </p>
      <PrimeButton
        @click="$emit('continue')"
        data-testid="verification-back-button"
        class="min-h-12 min-w-12 touch-manipulation"
      >
        Back to home
      </PrimeButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import PrimeButton from './ui/PrimeButton.vue';
import { useAuth } from '@/composables/useAuth';

const props = defineProps<{
  token: string;
}>();

defineEmits<{
  continue: [];
}>();

const auth = useAuth();
const isLoading = ref(true);
const success = ref(false);
const errorMessage = ref('');

onMounted(async () => {
  try {
    await auth.verifyEmail(props.token);
    success.value = true;
  } catch (err: unknown) {
    errorMessage.value =
      err instanceof Error
        ? err.message
        : 'The verification link is invalid or has expired. Please sign up again.';
  } finally {
    isLoading.value = false;
  }
});
</script>
